import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IStateParamsService } from 'angular-ui-router';
import { find, reduce } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { dashboardSelector } from 'Src/ng2/store';
import { DASHBOARD_GRAPHS } from '../../../../ng2/shared/constants/dashboard-graphs.constant';
import { LoadDashboard } from './../../../../ng2/store/actions/dashboard-actions';

@Injectable()
export class DashboardGraphDataResolver {
  resolveSelectedDashboardGraphData($stateParams: IStateParamsService, store: Store<any>): Promise<any> {
    const destroy$: Subject<any> = new Subject();
    const dashboardKey: string = $stateParams.graphName;
    const graphConstData: object = this.getGraphData(dashboardKey);

    return new Promise(resolve => {
      store
        .pipe(
          select(dashboardSelector, { dashboardKey }),
          takeUntil(destroy$),
        )
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadDashboard({ schoolId: $stateParams.schoolId, graphName: dashboardKey }));
          if (loaded) {
            const graphState$ = store.pipe(select(dashboardSelector, { dashboardKey }));
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve({ data: graphState$, ...graphConstData });
          }
        });
    });
  }

  private getGraphData(graphKey: string): object {
    const graphs = reduce(DASHBOARD_GRAPHS, (accum, graphsByCat) => (accum = [...accum, ...graphsByCat]), []);
    const graph = find(graphs, { key: graphKey });
    return graph;
  }
}
